import { Routes, RouterModule } from '@angular/router';



import { AdminLayoutComponent } from '../_admin-layout/admin-layout.component';
import { HistoricoEmailComponent } from './historicoEmail/historico-email.component';
import { HistoricoAlteracaoComponent } from './historicoAlteracao/historico-alteracao.component';

const PropostaRoutes: Routes = [
  { path: '', component: AdminLayoutComponent,
          children: [
            { path: 'proposta/historico-email', component: HistoricoEmailComponent },
            { path: 'proposta/historico-alteracao/:id', component: HistoricoAlteracaoComponent }
          ]
      }
  ];

export const PropostaRouting = RouterModule.forChild(PropostaRoutes);



// WEBPACK FOOTER //
// ./src/app/components/proposta/proposta.routing.ts